import ReturnApi from '@/ReturnApi';

const DEBUG_MARKER = '[Debug Mode]';
const NAMESPACE_TOKEN = /\s*[A-Za-z0-9_]+(\\[A-Za-z0-9_]+)+\.?/g;

// O backend anexa detalhe técnico à mensagem quando está em debug
// ("... APP\MODELS\X [Debug Mode] => No query results ..."). Isso não serve pro
// usuário: corta o rastro e mantém só a frase. O original vai pro console fora de produção.
export function sanitizeApiMessage(message) {
  if (!message) return message;

  const raw = String(message);
  const debugIndex = raw.indexOf(DEBUG_MARKER);
  const withoutDebug = debugIndex === -1 ? raw : raw.slice(0, debugIndex);
  const cleaned = withoutDebug.replace(NAMESPACE_TOKEN, '').trim();

  if (cleaned !== raw && process.env.NODE_ENV !== 'production') {
    console.warn('[api] mensagem original:', raw);
  }

  return cleaned || raw;
}

export function getApiErrorMessage(error, fallbackMessage) {
  const data = error && error.response && error.response.data;

  return (
    sanitizeApiMessage(data && data.message) ||
    fallbackMessage ||
    (error && error.message) ||
    'Ocorreu um erro inesperado'
  );
}

const FORM_VALIDATION_TYPE = 3;
const MODAL_TYPE = 2;

export function handleApiError(vm, error, fallbackMessage) {
  const data = error && error.response && error.response.data;

  if (data && data.type && (data.message || data.title)) {
    const type =
      Number(data.type) === FORM_VALIDATION_TYPE ? MODAL_TYPE : data.type;
    const payload = { ...data, type, message: sanitizeApiMessage(data.message) };
    new ReturnApi(payload, vm, false, false, false, false);
    return;
  }

  vm.$snotify.error(getApiErrorMessage(error, fallbackMessage), 'Erro');
}
